import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import "../screenstyles/Product.css";
import {
  getAlwaseetOrders,
  AlwaseetOrder,
} from "../services/alwaseetService";

const cardStyle: React.CSSProperties = {
  background: "#fff",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
  border: "1px solid #eef2f7",
  marginBottom: "20px",
};

const rowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "220px 1fr",
  gap: "12px",
  padding: "10px 0",
  borderBottom: "1px solid #f1f5f9",
};

const labelStyle: React.CSSProperties = {
  fontWeight: 700,
  color: "#334155",
};

const valueStyle: React.CSSProperties = {
  color: "#0f172a",
};

const formatCurrency = (value: string | number | undefined) => {
  const amount = Number(value || 0);
  return `${amount.toLocaleString("en-US")} دينار`;
};

export default function AlwaseetOrderDetails() {
  const { id } = useParams();
  const [order, setOrder] = useState<AlwaseetOrder | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchOrder = async () => {
    setLoading(true);
    try {
      const orders = await getAlwaseetOrders();
      const found = (orders || []).find(
        (item) => String(item.id) === String(id)
      );
      setOrder(found || null);
    } catch (error) {
      console.error("Error loading order details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  if (loading) {
    return <div className="product-container">جاري تحميل تفاصيل الطلب...</div>;
  }

  if (!order) {
    return <div className="product-container">لم يتم العثور على الطلب</div>;
  }

  return (
    <div className="product-container">
      <div style={cardStyle}>
        <h2 style={{ marginBottom: "20px" }}>تفاصيل طلب الوسيط</h2>

        <div style={rowStyle}>
          <div style={labelStyle}>رقم الطلب</div>
          <div style={valueStyle}>{order.id}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>اسم العميل</div>
          <div style={valueStyle}>{order.client_name}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>الهاتف</div>
          <div style={valueStyle}>{order.client_mobile}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>هاتف إضافي</div>
          <div style={valueStyle}>{order.client_mobile2 || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>المدينة</div>
          <div style={valueStyle}>{order.city_name || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>المنطقة</div>
          <div style={valueStyle}>{order.region_name || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>الموقع</div>
          <div style={valueStyle}>{order.location}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>نوع المادة</div>
          <div style={valueStyle}>{order.type_name}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>عدد القطع</div>
          <div style={valueStyle}>{order.items_number}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>السعر</div>
          <div style={valueStyle}>{formatCurrency(order.price)}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>أجرة التوصيل</div>
          <div style={valueStyle}>{formatCurrency(order.delivery_price)}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>الحالة</div>
          <div style={valueStyle}>{order.status || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>استبدال</div>
          <div style={valueStyle}>
            {String(order.replacement) === "1" ? "نعم" : "لا"}
          </div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>ملاحظات التاجر</div>
          <div style={valueStyle}>{order.merchant_notes || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>ملاحظات المشكلة</div>
          <div style={valueStyle}>{order.issue_notes || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>تاريخ الإنشاء</div>
          <div style={valueStyle}>{order.created_at || "-"}</div>
        </div>

        <div style={rowStyle}>
          <div style={labelStyle}>آخر تحديث</div>
          <div style={valueStyle}>{order.updated_at || "-"}</div>
        </div>
      </div>
    </div>
  );
}